<section class="recovery-page">
  <div class="recovery-orb recovery-orb--one"></div>
  <div class="recovery-orb recovery-orb--two"></div>

  <main class="recovery-card">
    <a routerLink="/login" class="back-link">← Back to sign in</a>

    @if (!submitted()) {
      <div class="recovery-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24"><path d="M7 10V7a5 5 0 0 1 10 0v3"/><rect x="4" y="10" width="16" height="11" rx="2"/><path d="M12 14v3"/></svg>
      </div>
      <span class="eyebrow">Account recovery</span>
      <h1>Forgot your password?</h1>
      <p class="intro">Enter your registered email address to start a secure administrator-assisted reset.</p>

      <form [formGroup]="form" (ngSubmit)="submit()">
        <label for="recovery-email">Registered email address</label>
        <div class="input-shell">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 6h16v12H4zM4 7l8 6 8-6"/></svg>
          <input id="recovery-email" type="email" formControlName="email" placeholder="name@example.com" autocomplete="email">
        </div>
        @if (form.controls.email.touched && form.controls.email.invalid) {
          <small class="field-error">Enter a valid registered email address.</small>
        }
        <button type="submit">Continue <span>→</span></button>
      </form>

      <div class="security-note"><span>✓</span> Your account details remain private and protected.</div>
    } @else {
      <div class="recovery-icon recovery-icon--success" aria-hidden="true">✓</div>
      <span class="eyebrow">Next step</span>
      <h1>Contact your administrator</h1>
      <p class="intro">
        Password resets for RE-DSM accounts require administrator verification. Ask your MSLDC administrator to reset the account registered as:
      </p>
      <strong class="submitted-email">{{ form.controls.email.value }}</strong>
      <div class="info-box">
        <span>i</span>
        <p>For your security, the portal does not confirm whether an email address exists or change passwords through an unauthenticated link.</p>
      </div>
      <button type="button" class="secondary-button" (click)="editEmail()">Use another email</button>
      <a routerLink="/login" class="primary-link">Return to sign in →</a>
    }
  </main>
</section>
